import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

// Images, Vidoes
import { images } from '../../assets/images'
import axios from 'axios'
import { ShowErrorMsg } from '../../utils/ShowErrorMsg'

const LoginForm = ({ isCounselor }) => {
   // isCounselor 0일 때 개인, 1일 때 상담사

   const navigate = useNavigate();

   const [mailFormData, setMailFormData] = useState({
      c_identified: '',
      password: '',
   });

   const handleChange = (e) => {
      const { name, value } = e.target
      setMailFormData((prev) => ({
         ...prev,
         [name]: value
      }))
   }

   const mailLogin = async (e) => {
      e.preventDefault(); // 기본 동작 막음

      try {
         const response = await axios.post(`${process.env.REACT_APP_API_URL}/login/${isCounselor}`,
            mailFormData, {
            withCredentials: true, // 쿠키 포함
         });

         alert(response.data?.msg || '정상적으로 완료 되었습니다.')
         navigate('/')
      } catch (error) {
         console.error(error)
         ShowErrorMsg(error)
         if (error.response.status === 403) {
            navigate('/join/counselor/complete')
         }
      }
   }


   // 애플 심사 때문에 웹뷰일 때는 애플 로그인 로직 추가
   const isWebView = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      return /wv|webview|ip(hone|ad|od).*safari/i.test(userAgent);
   }

   const handleClickAppleLogin = () => {
      // alert('준비 중입니다.');
      // return;
      if (isWebView()) {
         window.postMessage(JSON.stringify({ key: 'APPLE_LOGIN' }));
      } else {
         window.location.href = `${process.env.REACT_APP_API_URL}/login/${isCounselor}/apple`
      }
   }

   const afterSocialLogin = async (event) => {
      let result = null;
      // alert(event.data)

      if (event && event.data && typeof event.data === 'string') {
         try {
            result = JSON.parse(event.data);
         } catch (e) {
            console.error("Invalid JSON data:", e);
         }
      }


      try {
         const response = await axios.post(`${process.env.REACT_APP_API_URL}/login/${isCounselor}/apple/app`, {
            id_token: result.value.idToken,
            email: result.value.email,
            fullName: result.value.fullName,
         }, {
            withCredentials: true // 쿠키 전송 및 저장 허용
         })

         if (response.data.data.type === 1) {
            alert('성공적으로 처리되었습니다.')
         }
         window.location.href = response.data.data.url;
      } catch (error) {
         ShowErrorMsg(error)
      }

   }

   useEffect(() => {
      window.addEventListener('message', afterSocialLogin);
      document.addEventListener('message', afterSocialLogin);

      return () => {
         window.removeEventListener('message', afterSocialLogin);
         document.removeEventListener('message', afterSocialLogin);
      }
   }, [])

   return (
      <div className="subpage">
         <section className="user-section">
            <div className="user-wrap">
               <div className="title-wrap row-group">
                  <h2 className="title">
                     {isCounselor ? '상담사 로그인' : '로그인'}
                  </h2>
                  <p className="txt">
                     마인드 인사이트를 통해 진정한 '나'를 발견하세요.
                  </p>
               </div>
               <form onSubmit={mailLogin}>
                  <fieldset>
                     <div className="input-wrap">
                        <input
                           onChange={handleChange}
                           name='c_identified'
                           className="form-input"
                           type="text"
                           placeholder="이메일(아이디)"
                        />
                        <input
                           onChange={handleChange}
                           name='password'
                           className="form-input"
                           type="password"
                           placeholder="비밀번호"
                        />
                     </div>
                     <button
                        // onClick={() => mailLogin()}
                        className="hi default-btn user-btn btn-bk login-btn"
                        type='submit'
                     >
                        로그인
                     </button>
                  </fieldset>
               </form>
               <div className="user-link-wrap">
                  <Link to={`/find-account/id/${isCounselor ? 'counselor' : ''}`} className="find-btn"> 아이디 찾기</Link>
                  <span className="div-mark"></span>
                  <Link to={`/find-account/pw/${isCounselor ? 'counselor' : ''}`} className="find-btn"> 비밀번호 찾기</Link>
               </div>

               <div className="login-sns-wrap">
                  <Link to={`${process.env.REACT_APP_API_URL}/login/${isCounselor}/naver`} className="btn">
                     <img src={images.never_login} alt="" />
                  </Link>
                  <Link to={`${process.env.REACT_APP_API_URL}/login/${isCounselor}/kakao`} className="btn">
                     <img src={images.kakao_login} alt="" />
                  </Link>
                  <button
                     onClick={handleClickAppleLogin}
                     className="btn"
                  >
                     <img src={images.apple_login} alt="" />
                  </button>
               </div>

               <p className="sub">
                  아직 <span className="green">마인드 인사이트</span>의 회원이 아니신가요?
               </p>
               <Link to="/join/select" className="join-btn">회원가입</Link>
            </div>
         </section>
      </div>
   )
}

export default LoginForm